<template>
    <div class="container" v-loading="loading">
        <img src="../../assets/返回.png" alt="" class='goback' @click="goback()">
        <el-row :gutter="20">
            <el-col :span="67">
                <div class="modulestatus">
                    <modulestatus></modulestatus>
                </div>
                <div class="datatable">
                    <datatable></datatable>
                </div>
                <div class="dashedchart">
                    <dashedchart></dashedchart>
                </div>
            </el-col>
            <el-col :span="10" class="right">
                <div class="warningbox">
                    <warningbox></warningbox>
                </div>
                <div class="historychart">
                    <historychart>
                    </historychart>
                </div>
                <div class="bottom_box">
                    <div class="equipment">
                        <equipment></equipment>
                    </div>
                    <div class="right_bottom">
                        <div class="deplete">
                            <deplete></deplete>
                        </div>
                        <div class="time">
                            <runtime></runtime>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import modulestatus from "./component/Modulestatus.vue";
import datatable from "./component/datatable.vue";
import dashedchart from "./component/dashedchart.vue";
import warningbox from "./component/warning.vue"
import historychart from './component/historychart.vue'
import equipment from './component/equipment.vue'
import deplete from './component/deplete.vue'
import runtime from './component/runtime.vue'
//  // import config from '@/utils/config';;

export default {
    data() {
        return {
            allControlData: { name: "" },
            show: true,
            loading: true
        };
    },
    components: {
        modulestatus,
        datatable,
        dashedchart,
        warningbox,
        historychart,
        equipment,
        deplete,
        runtime
    },
    watch: {
        "$route.query.index"(newVal, oldVal) {
            console.log(newVal);
            this.openIndex = newVal
            this.getinflowcod(this.openIndex)
        },
        "$store.state.loadingnumber"(newVal, oldVal) {
            console.log(newVal, "this is loading number------------")
            // this.calendarChart.resize()
            if (newVal == 0) {
                this.loading = false
            }
        },
    },
    mounted() {
        console.log(123231);
        this.openIndex = this.$route.query.index;
        // this.getControlData(this.openIndex);
        // this.getinflowcod(this.openIndex)
    },
    methods: {
        gotoControl() {
            this.$router.push("/AI/control");
        },
        closedrawer() {
            if (this.$route.query.index == 4) {
                this.$refs.fangzhenIndex.getChartData(this.$route.query.index);
            }
        },
        async getControlData(index) {
            const { data: res } = await this.$http.get("/modules/init", {
                params: { index: index },
            });
            this.allControlData = res.data.result;
            this.$store.commit("changerunbt", res.data.result.runbtn);
        },
        async getinflowcod(index) {
            // console.log(index);
            const { data: res } = await this.$http.get("/modules/getinput", {
                params: { index: index },
            });
            console.log(res.data.result);
            if (res.data.result.length < 1) {
                console.log(213213213123);
                // this.show = false
                this.show = true
            } else {
                this.show = false
                this.inflowcod = res.data.result;
            }
            // this.inflow.target = res.data.result;
            // // console.log(this.inflow.target);
            // this.inflow.current = res.data.result;
            // console.log(this.inflow.current);
        },
        goback() {
            this.$router.go(-1)
        }
    },
};
</script>

<style lang="scss" scoped>
.container {
    height: 95vh;
    margin-left: 32px;

    .modulestatus {
        margin-bottom: 24.6px;
        // background-color: #212121FF;
    }

    .datatable {
        margin-bottom: 26px;
    }

    .dashedchart {
        width: 773.7px;
        height: 302.9px;
        opacity: 1;
        border-radius: 26px;
    }

    .bottom-box {
        display: flex;

        .right {
            margin-left: 20px;
            margin-right: 20px;
        }
    }
}

.right {
    margin-left: 10px
}

.left {
    margin-left: 50px;
}

.openright {
    margin-right: 50px
}

.content-box {
    width: 100%;
}

.historychart {
    margin-top: 26px;
}

.goback {
    cursor: pointer;
    width: 20.62px;
    height: 20.9px;
}

.bottom_box {
    margin-top: 26px;
    display: flex;

    .equipment {
        margin-right: 29px;
    }

    .deplete {
        margin-bottom: 26px;
    }
}

.hover {
    i {
        width: 100px;
        font-size: 25px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
}

@import "/src/assets/css/index1.scss";

.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 1s;
}

.fade-enter-to {
    opacity: 1;
}

.centerfade-enter-active {
    animation: centerslidein 1s linear;
}

.centerfade-leave-active {
    animation: centerslidein 1s linear reverse;
}

@keyframes centerslidein {
    from {
        transform: translateY(-100%);
    }

    to {
        transform: translateY(0px);
    }
}

.rightfade-enter-active {
    animation: rightslidein 1s linear;
}

.rightfade-leave-active {
    animation: rightslidein 1s linear reverse;
}

@keyframes rightslidein {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0px);
    }
}

.fangzhenfade-enter-active {
    animation: fangzhenslidein 1s linear;
}

.fangzhenfade-leave-active {
    animation: fangzhenslidein 1s linear reverse;
}

@keyframes fangzhenslidein {
    from {
        transform: translateX(100%);
    }

    to {
        transform: translateX(0px);
    }
}

.historyfade-enter-active {
    animation: historyslidein 1s linear;
}

.historyfade-leave-active {
    animation: historyslidein 1s linear reverse;
}

@keyframes historyslidein {
    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0px);
    }
}
</style>
